import React, { useEffect } from "react";
import logo from "../images/logo.svg";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from 'react-query'
import {
  Button,
  Layout,
  Affix,
  Avatar,
  Typography,
  Popover,
  Space,
  Divider,
  Menu,
  Dropdown,
  Badge,
  message,
  Drawer
} from "antd";
import { UserOutlined, DownOutlined, MenuOutlined } from "@ant-design/icons";
import { useNavigator } from "../../utilities/navigation";
import "./styles.css";
import NotificationDrawer from "../common/NotificationModal";
import { BellOutlined } from "@ant-design/icons";
import { NotificationApis } from "./api";
import { useState } from "react";

export default function Header(props) {
  console.log("custom header props")
  console.log(props)
  const { Header } = Layout;
  const { Text } = Typography;
  const [navigator] = useNavigator();
  const [visible, setVisible] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const [notificationCount, setCount] = React.useState(0);
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
  // const [currentKey, setCurrent] = React.useState(props?.menu?.[0]?.path)
  const [currentKey, setCurrent] = React.useState('/marketplace')
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState('')
  const [mobileMenu, setMobileMenu] = useState(false)

  const currentMenu = (key) => {
    setCurrent(currentKey)
  }
  const { isLoading: getNotificationLoading, refetch } = useQuery(['getNotification', loggedUser], () => {
    return NotificationApis.getUserNotification(loggedUser?.jwtToken)
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data?.data != null) {
        setCount(data?.data?.length)
        setNotifications(data?.data)
      }
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const OnSuccessfullDelete = (data) => {
    setId('')
    if (data?.userdata?.id?.length > 0) {
      const value = data?.userdata?.id[0]
      const deleteNotification = notifications?.filter(item => item?._id != value)
      setNotifications(deleteNotification)
      setLoading(false)
      message.success("Notification Delete Successfully", 3)
    }
    else {
      setNotifications([])
      message.success("All Notification Clear Successfully", 3)
    }

  }
  console.log("current item is")
  console.log(currentKey)
  const mutation = useMutation(async (data) => {
    var response = NotificationApis.deleteUserNotification(data, loggedUser?.jwtToken)
    return { ...response, userdata: data }
  },
    {
      onSuccess: OnSuccessfullDelete,
      onError: (err) => {
        setLoading(false)
        setId('')

      }
    }
  )

  const deleteNotification = (data) => {
    console.log(data)
    if (data?.id?.length > 0) {
      setId(data?.id[0])
      setLoading(true)
    }
    mutation.mutateAsync(data)
  }
  React.useEffect(() => {
    if (loggedUser != null) {
      refetch()
    }
  }, []);
  const menu = (
    <Menu>
      <Menu.Item>
        <Space className="spaceText">
          <Avatar size="small" icon={<UserOutlined />} />
          <Text strong>{loggedUser?.email}</Text>
        </Space>
      </Menu.Item>
      <Menu.Item onClick={() => {
            navigator("/profile");
          }}>
            {loggedUser?.type != "admin" ? 
            
        <Text
          strong
          onClick={() => {
            navigator("/profile");
          }}
        >
          My Profile
        </Text> : null
          }
      </Menu.Item>
      <Menu.Item  onClick={() => {
            localStorage.removeItem("loggedUser");
            navigator("/login");
          }}>
        <Text
          strong
         
        >
          Logout
        </Text>
      </Menu.Item>
    </Menu>
  );
  const content = (
    <div>
      <Space className="spaceText">
        <Avatar icon={<UserOutlined />} />
        <Text strong>{loggedUser?.email}</Text>
      </Space>
      <Divider />
      <Text
        strong
        onClick={() => {
          localStorage.removeItem("loggedUser");
          navigator("/login");
        }}
      >
        Logout
      </Text>
    </div>
  );
  return (
    <>
      <NotificationDrawer
        notifications={notifications}
        visible={visible}
        hidePop={() => {
          setVisible(false);
        }}
        mutation={mutation}
        deleteNotification={deleteNotification}
        loading={loading}
        id={id}

      ></NotificationDrawer>
      <Drawer
        placement='right'
        className="menuDrawer"
        onClose={() => { setMobileMenu(false) }}
        visible={mobileMenu}
        extra={
          loggedUser != null ? (
            <>
              <Badge
                onClick={() => {
                  setVisible(true);
                }}
                count={notificationCount}
                size="default"
                className="notificationBedge"
              >
                <BellOutlined />
              </Badge>
              <Avatar icon={<UserOutlined />} />
              <Dropdown
                placement="bottomRight"
                className="profilePOpover"
                trigger={['click']}
                overlay={menu}
              >
                <Text strong>
                  {loggedUser?.firstName}
                  <DownOutlined className="profileDownArrow" />
                </Text>
              </Dropdown>
            </>
          ):
          <Space>
            <Button type="primary" onClick={() => {
              setMobileMenu(false)
              navigator("/login");

            }}>login</Button>
            <Button className="reg-btn" onClick={() => {
              setMobileMenu(false)
              navigator("/registration");
            }}>
              Register
            </Button>
          </Space>
        }
      >
        <Menu onClick={() => {console.log("menu is clicked") }} selectedKeys={[currentKey]} mode="vertical">
          {
            props?.menu?.map(item => {

              return <Menu.Item className="menuItem" key={item?.path} onClick={() => {
                // alert(item.path)
                console.log('menu item is clicked')
                navigator(item?.path);
                setCurrent(item?.path)

                // navigator()
              }}>
                {item?.title}
              </Menu.Item>
            })
          }
        </Menu>
      </Drawer>
      <Affix>
        <Header className="login-header">
          <div className="logo companylogo">
            <img src={logo} />

            <div className="MainMenu">
              {loggedUser != null ? <Menu onClick={() => { }} selectedKeys={[currentKey]} mode="horizontal">
                {
                  props?.menu?.map(item => {

                    return <Menu.Item className="menuItem" key={item?.path} onClick={() => {
                      navigator(item?.path);
                      setCurrent(item?.path)

                      // navigator()
                    }}>
                      {item?.title}
                    </Menu.Item>
                  })
                }
              </Menu>
                : null}
            </div>
          </div>
          <div className="login-action">
            {loggedUser != null ? (
              <>
                <Badge
                  onClick={() => {
                    setVisible(true);
                  }}
                  count={notificationCount}
                  size="default"
                  className="notificationBedge"
                >
                  <BellOutlined />
                </Badge>
                <Avatar icon={<UserOutlined />} />
                <Dropdown
                 trigger={['click']}
                  placement="bottomRight"
                  className="profilePOpover"
                  overlay={menu}
                >
                  <Text strong>
                    {loggedUser?.firstName}
                    <DownOutlined className="profileDownArrow" />
                  </Text>
                </Dropdown>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button type="primary" icon={<UserOutlined />} size="large">
                    Login
                  </Button>
                </Link>
                <Link to="/registration">
                  <Button type="primary" size="large" className="reg-btn">
                    Register
                  </Button>
                </Link>
              </>
            )}
          </div>
          <div className="mobileMenu">
            <Button onClick={() => {
              setMobileMenu(true)
            }}><MenuOutlined /></Button>
          </div>
        </Header>
      </Affix>
    </>
  );
}
